import { PARTNER_MANAGEMENT_PERMISSION_KEYS as PM } from "../../../../../utils/permissions/partnerManagementPermissionKeys";

export type PartnerSidebarMenuItem = {
  key: string;
  label: string;
  icon: string;
  permissionKey: string;
  skipPermissionCheck?: boolean;
};

export const PARTNER_SIDEBAR_MENU_ITEMS: PartnerSidebarMenuItem[] = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: "home",
    permissionKey: PM.PARTNER_ADMIN_DASHBOARD,
  },
  {
    key: "partner-details",
    label: "Partner Details",
    icon: "user",
    permissionKey: PM.PARTNER_CONFIGURATIONS,
  },
  {
    key: "partner-users",
    label: "Partner Users",
    icon: "userGroup",
    permissionKey: PM.MANAGE_PARTNER_USER,
  },
  {
    key: "services-and-subscriptions",
    label: "Services & Subscriptions",
    icon: "cartShopping",
    permissionKey: PM.CONTRACT_MANAGEMENT,
  },
  {
    key: "orders",
    label: "Orders",
    icon: "memo",
    permissionKey: PM.ADMIN_ORDER_MANAGEMENT,
  },
  {
    key: "project-onboarding",
    label: "Projects",
    icon: "folderBlank",
    permissionKey: PM.ADMIN_PROJECT_MANAGEMENT,
  },
  {
    key: "notes",
    label: "Notes",
    icon: "memoCircleCheck",
    permissionKey: PM.PARTNER_NOTES,
  },
  {
    key: "partner-program",
    label: "Partner Program",
    icon: "awardSimple",
    permissionKey: PM.ADMIN_PARTNER_PROGRAM,
  },
  {
    key: "history-log",
    label: "History Log",
    icon: "clockRotateLeft",
    permissionKey: PM.ACTIVITY_LOG,
  },
];

export function getPermissionKeyForPartnerTab(tabKey: string): string {
  return (
    PARTNER_SIDEBAR_MENU_ITEMS.find((m) => m.key === tabKey)?.permissionKey ??
    PM.PARTNER_CONFIGURATIONS
  );
}
